import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import RepFin from "./rep-fin";
import RepAbon from "./rep-abon";
import RepProduct from "./rep-product";
import { isMobile } from '../../extensions/design';
import "../../controls/print-page/print-page.css"

const Reports = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = useMemo(() => searchParams.get('tab') || 'fin', [searchParams]);

  const getBody = () => {
    switch (page) {
      case "fin": return <RepFin />;
      case "abon": return <RepAbon />;
      case "product": return <RepProduct />;
      default: return null;
    }
  }

  const getItem = (title, link) => (
    <div className={"col-one-title-item" + (link === page ? " col-one-title-selected" : "")} onClick={() => setSearchParams({ tab: link })} >
      {title}
    </div>
  );

  return (
    <div className="sport-form-content">
      {isMobile && <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Отчеты</div>}
      <div className="col-one-main">
        {isMobile ? (<> </>) : (<div className="col-one-title">
          {getItem('Финансовый', 'fin')}
          {getItem('По продажам абонементов, пакетов', 'abon')}
          {getItem('По проданным товарам и оказанным услугам', 'product')}
        </div>) }
        <div className="col-one-col">{getBody()}</div>
      </div>
    </div>
  );
};

export default Reports;